(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  function restore(dialog) {
    const state = states.get(dialog);
    if (!state) return;
    clearTimeout(state.timer);
    dialog.classList.remove('is-closing');
    document.documentElement.style.overflow = state.overflow;
    state.trigger?.setAttribute('aria-expanded', 'false');
    if (state.trigger?.isConnected) state.trigger.focus({ preventScroll: true });
    states.delete(dialog);
  }
  function close(dialog, immediate = false) {
    if (!dialog?.open || dialog.classList.contains('is-closing')) return;
    if (immediate || reduced.matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    const state = states.get(dialog);
    if (state) state.timer = setTimeout(() => dialog.close(), 180);
    else dialog.close();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-nav]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.openNav);
      if (!dialog || dialog.open) return;
      states.set(dialog, { trigger: opener, overflow: document.documentElement.style.overflow });
      document.documentElement.style.overflow = 'hidden';
      opener.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      const initialFocus = dialog.querySelector('[autofocus]') || dialog.querySelector('[data-close-nav]');
      initialFocus?.focus({ preventScroll: true });
      return;
    }
    const dialog = event.target.closest('[data-nav-dialog]');
    if (!dialog) return;
    if (event.target.closest('[data-close-nav]')) { close(dialog); return; }
    if (event.target.closest('a')) { close(dialog, true); return; }
    if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(dialog);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('[data-nav-dialog][open]');
    if (!dialog) return;
    event.preventDefault(); event.stopPropagation(); close(dialog);
  }, true);
  document.addEventListener('cancel', event => {
    if (!event.target.matches('[data-nav-dialog]')) return;
    event.preventDefault(); close(event.target);
  }, true);
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-nav-dialog]')) restore(event.target);
  }, true);
  document.addEventListener('shopify:section:unload', () => {
    document.querySelectorAll('[data-nav-dialog][open]').forEach(dialog => { dialog.close(); restore(dialog); });
  });
  let releaseOffers = () => {};
  function mountOffers() {
    releaseOffers();
    const root = document.querySelector('[data-offer-scroll]');
    const group = root?.querySelector('.kn-offer-bar__group');
    if (!root || !group) return;
    const controller = new AbortController();
    const measure = () => {
      const width = group.getBoundingClientRect().width;
      if (width) root.style.setProperty('--kn-offer-duration', `${width / 28}s`);
    };
    const visibility = () => root.classList.toggle('is-offer-hidden', document.hidden);
    const resize = new ResizeObserver(measure);
    resize.observe(group);
    const intersection = new IntersectionObserver(entries => root.classList.toggle('is-offer-offscreen', !entries[0].isIntersecting));
    intersection.observe(root);
    document.addEventListener('visibilitychange', visibility, { signal: controller.signal });
    measure();
    visibility();
    releaseOffers = () => { controller.abort(); resize.disconnect(); intersection.disconnect(); };
  }
  mountOffers();
  document.addEventListener('shopify:section:load', mountOffers);
})();
